import MovieIcon from '@mui/icons-material/Movie';
import { Chip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { publishCardMessages } from '../publish-messages';

interface UploadCardEditIndicatorProps {
  edit: { name: string };
}

/**
 * Outlined chip showing the linked video-editor edit name on social upload cards.
 */
export function UploadCardEditIndicator({ edit }: UploadCardEditIndicatorProps) {
  return (
    <Chip
      sx={{ pl: 0.5, flexShrink: 0 }}
      icon={<MovieIcon fontSize="small" color="secondary" />}
      label={
        <FormattedMessage {...publishCardMessages.editionWithName} values={{ name: edit.name }} />
      }
      size="small"
      variant="outlined"
    />
  );
}
